/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Send_Size_LimitInputs */

const en_mcp_cap_send_size_limit = /** @type {(inputs: Mcp_Cap_Send_Size_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to 20 MiB per file`)
};

const es_mcp_cap_send_size_limit = /** @type {(inputs: Mcp_Cap_Send_Size_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta 20 MiB por archivo`)
};

/**
* | output |
* | --- |
* | "Up to 20 MiB per file" |
*
* @param {Mcp_Cap_Send_Size_LimitInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_send_size_limit = /** @type {((inputs?: Mcp_Cap_Send_Size_LimitInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Send_Size_LimitInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_send_size_limit(inputs)
	return en_mcp_cap_send_size_limit(inputs)
});